
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  position:relative;

  --grid-wrapper-display:grid;

  --gap-xs:var(--spacing-4);
  --gap-sm:var(--spacing-7);
  --gap-md:calc(var(--gap-sm) * 2);

  --padding-x:1rem;

  --padding-y-xs:clamp(
    0.5rem,
    0.8571428571428571rem + 0.8571428571428571vw,
    1.2rem
  );

  --padding-y-sm:clamp(1rem, 1.2rem + 1.7vw, 2.4rem);

  --padding-y-md:clamp(
    2.5rem,
    2.142857142857143rem + 4.285714285714286vw,
    5rem
  );

  --padding-y-lg:clamp(
    3.5rem,
    2.5714285714285716rem + 7.142857142857142vw,
    8rem
  );
}

  :host .grid-wrapper{
    margin:0 auto;
    display:var(--grid-wrapper-display);
    grid-template-columns:repeat(12, minmax(0, 1fr));
    position:relative;
  }

:host([background-color='blue']){
  background-color:var(--brand-primary-dark-blue);
  color:var(--brand-gray-100);
}

:host([background-color='light-blue']){
  background-color:var(--brand-blue-200);
}

:host([background-color='transparent']){
  background-color:transparent;
}

:host([background-color='white']){
  background-color:var(--brand-gray-100);
}

:host([background-color='gray']){
  background-color:var(--brand-gray-200);
}

:host([background-color='green']){
  background-color:var(--brand-green-900);
}

:host([x-padding='true']){
  padding-left:var(--padding-x);
  padding-right:var(--padding-x);
}

.max-w-small{
  max-width:var(--max-w-small);
}

.max-w-medium{
  max-width:var(--max-w-medium);
}

.max-w-none{
  max-width:var(--max-w-none);
  margin-left:auto;
  margin-right:auto;
}

.max-w-limit{
  max-width:var(--max-w-limit);
  margin-left:auto;
  margin-right:auto;
}

@media (min-width: 768px){
  .max-w-small{
    width:var(--w-percent-small);
  }

  .max-w-medium{
    width:var(--w-percent-medium);
  }
}

.y-padding-none{
  padding-top:0;
  padding-bottom:0;
}

.y-padding-small{
  padding-top:var(--padding-y-sm);
  padding-bottom:var(--padding-y-sm);
}

.y-padding-medium{
  padding-top:var(--padding-y-md);
  padding-bottom:var(--padding-y-md);
}

.y-padding-large{
  padding-top:var(--padding-y-lg);
  padding-bottom:var(--padding-y-lg);
}

.gap-extra-small{
  gap:var(--gap-xs) 0;
}

.gap-small{
  gap:var(--gap-sm) 0;
}

.gap-medium{
  gap:var(--gap-md) 0;
}

@media (min-width: 768px){
  .gap-extra-small{
    gap:var(--gap-xs);
  }

  .gap-small{
    gap:var(--gap-sm);
  }

  .gap-medium{
    gap:var(--gap-md);
  }
}
`;